module.exports = __webpack_public_path__ + "img/card.6a011078.png";